export const onlinePanel = {
    meta: {
        title: 'Онлайн-табло вылетов и прилётов рейсов Utair - статус рейсов на официальном сайте авиакомпании «ЮТэйр»',
        description:
            'Расписание рейсов авиакомпании «ЮТэйр». Онлайн-табло вылетов ' +
            'и прилётов рейсов Utair. Узнать статус рейса на официальном сайте авиакомпании.',
    },
};
